import React from 'react'
import { BUTTON_TYPE_PRIMARY } from 'components/common/Button/constants'
import { Button as MaterialButton } from '@material-ui/core'
import { StyledButton } from './Button.styles'
import { ButtonProps } from './Button.types'

const Button = ({
  type = BUTTON_TYPE_PRIMARY,
  children,
  onClick,
  customStyles,
  disabled,
  startIcon,
  endIcon,
}: ButtonProps) => (
  <StyledButton type={type} customStyles={customStyles} disabled={disabled}>
    <MaterialButton
      onClick={onClick}
      disabled={disabled}
      startIcon={startIcon}
      endIcon={endIcon}>
      {children}
    </MaterialButton>
  </StyledButton>
)

export default Button
